<template>
  <img :src="icon" class="rc-icon" alt />
</template>

<script>
export default {
  functional: true,
  props: {
    name: String
  },
  computed: {
    icon() {
      // if (this.name) {
      //   return require(`./img/${this.name}`);
      // }
      return "";
    }
  }
};
</script>
